import { Typography } from "@/components/kit";
import SvgIcon from "@/components/common/SvgIcon.tsx";
import { useTranslation } from "react-i18next";
import { ReactNode } from "react";

type EmptyStateProps = {
  description: string;
  text?: ReactNode;
  icon?: string;
  iconClassName?: string;
};
const NoResultWithIcon = ({
  description,
  icon,
  text,
  iconClassName,
}: EmptyStateProps) => {
  const { t } = useTranslation([]);

  return (
    <div className="flex flex-col justify-center items-center gap-4 h-full">
      <SvgIcon
        className={`w-32 h-32 ${iconClassName}`}
        fill="fill-unset"
        iconName={icon ?? "noResult"}
      />

      <div className="flex flex-col items-center gap-1">
        <Typography variant="Body1-Bold" color="text-gray-600">
          {t(description)}
        </Typography>
        {text}
      </div>
    </div>
  );
};

export default NoResultWithIcon;
